<template>
    <div style="height: 100vh; background-color: #f8f8f8;">
        <van-nav-bar title="隐私协议" left-arrow @click-left="$router.back()" :fixed="false" placeholder
            safe-area-inset-top></van-nav-bar>
        <div style="padding: 60px 10px;">
            <van-cell-group>
                <van-cell url="/protocolDetail/1" is-link title="技术服务合同" />
                <van-cell url="/protocolDetail/2" is-link title="金声玉亮系列会员服务协议" />
                <van-cell url="/protocolDetail/3" is-link title="金声玉亮隐私政策" />
            </van-cell-group>
        </div>
    </div>
</template>

<script>
import { Cell, CellGroup } from 'vant';

export default {
    name: 'ProtocolView',
    components: {
        'van-cell': Cell,
        'van-cell-group': CellGroup,
    },
};
</script>
<style scoped></style>